import { MerchantEnteredDaysResponse } from '../../../services'
import { ActionTypes } from '../actions'
import { BaseReducerState } from '../../../services/types'

type ResetMerchantEnteredDaysState = BaseReducerState & { data: string }

const initialState: ResetMerchantEnteredDaysState = {
  loading: false,
  success: false,
  message: '',
  data: null,
}

export const resetMerchantEnteredDays = (
  state: ResetMerchantEnteredDaysState = initialState,
  action: { type: string; res: MerchantEnteredDaysResponse }
): ResetMerchantEnteredDaysState => {
  switch (action.type) {
    case `${ActionTypes.DELETE_MERCHANT_ENTERED_DAYS}_REQUEST`:
      return {
        ...initialState,
        success: false,
        loading: true,
      }

    case `${ActionTypes.DELETE_MERCHANT_ENTERED_DAYS}_SUCCESS`:
      const { success, data, message } = <MerchantEnteredDaysResponse>action.res

      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    case `${ActionTypes.DELETE_MERCHANT_ENTERED_DAYS}_FAILURE`:
      return {
        ...state,
        loading: false,
        success: false,
        message: message,
      }
    case `${ActionTypes.DELETE_MERCHANT_ENTERED_DAYS}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
